/* Geolocation */

function getCookie(name) {
const value = "; " + document.cookie;
const parts = value.split("; " + name + "=");
if (parts.length == 2) return parts.pop().split(";").shift();
}

const localization = getCookie('localization');
console.log('Localization: ' + localization);

// Check if the shopify localization cookie exists and if not AU/NZ show the currency selector
if (localization != 'AU' && localization != 'NZ') {
document.addEventListener('DOMContentLoaded', function() {
    document.body.classList.add('international');
});
console.log('Showing currency selector');
}

// Use shopify browsing context suggestions to get the country code
let domain = window.location.protocol + '//' + window.location.hostname;
let jsonEndpoint = domain + "/browsing_context_suggestions.json";
let url = jsonEndpoint;

// If url paramater for override is set, change the jsondata
const urlParams = new URLSearchParams(window.location.search);
const countryOverride = urlParams.get('country');

// If we havent already checked the location this session, lets set the currency
if(!sessionStorage.currencyIsSet || countryOverride != null) {

// remove the urlparamter to prevent looping
if (countryOverride != null) {
    history.replaceState({}, document.title, window.location.pathname);
}

fetch(url)
    .then(response => response.json())
    .then(data => {
    let jsondata = data;
    let country = jsondata.detected_values.country.handle;

    console.log('Detected Country: ' + country);

    if (countryOverride) {
        country = countryOverride;
        console.log('Override Country: ' + country);
    } 

    // Set the country codes
    const europeCountryCodes = ['AL', 'AD', 'AM', 'AT', 'AZ', 'BY', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'GE', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'KZ', 'XK', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'UA', 'VA'];
    const ukCountryCodes = ['GB'];
    const usCountryCodes = ['US'];

    if (country == 'AU' || country == 'NZ') {
        // If we are in australia, we need to make sure that the localization cookie is also set correctly, to prevent an issue where they have previously been overseas and now in Australia but seeing incorrect pricing
        // Doesnt matter for the others as they will see the currency selector
        if (localization != 'AU' && localization != 'NZ') {
        console.log('Setting localization to AU');
        document.cookie = 'localization=AU; expires=' + new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toUTCString() + '; path=/';
        location.reload();
        } else {
        console.log('Remaining on AU');
        }
    }
    else if (europeCountryCodes.includes(country)) {
        console.log('Setting localization to FR');
        document.querySelector('#localization_form input[name="country_code"]').value = 'FR';
        document.querySelector('#localization_form').submit();
    }
    else if (ukCountryCodes.includes(country)) {
        console.log('Setting localization to GB');
        document.querySelector('#localization_form input[name="country_code"]').value = 'GB';
        document.querySelector('#localization_form').submit();
    }

    /* 
    else if (usCountryCodes.includes(country)) {
        document.querySelector('#localization_form input[name="country_code"]').value = 'US';
        document.querySelector('#localization_form').submit();
    }  
    */

    // Default to US
    else {
        console.log('Setting localization to US');
        document.querySelector('#localization_form input[name="country_code"]').value = 'US';
        document.querySelector('#localization_form').submit();
    }

    // Set session cookie, so this doesnt loop
    sessionStorage.currencyIsSet = "1";
    })
    .catch(error => console.error('Error fetching country data:', error));
}